import { render, staticRenderFns } from "./LoadingTest.vue?vue&type=template&id=3877b174&scoped=true"
import script from "./LoadingTest.vue?vue&type=script&lang=js"
export * from "./LoadingTest.vue?vue&type=script&lang=js"
import style0 from "./LoadingTest.vue?vue&type=style&index=0&id=3877b174&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877b174",
  null
  
)

export default component.exports